import React from 'react'
import Checkbox from '../../../../../components/CheckBox/CheckBox'
import {MOVE_GROUP, MOVE_SPACE_CHANGE} from '../MoveSequence'
import styled from 'styled-components'
import {
  NavigationButtons,
  BUTTON_TYPES
} from '../../../../Navigation/NavigationButtons/NavigatonButtons'
import {_L, useLocaleState} from '../../../../../context/LocaleContext'

const StyledContainer = styled.div`
  width: 600px;

  @media (max-width: 420px) {
    width: 100vw;
    height: calc(100vh - 80px);
    overflow-y: scroll;
    background-color: white;
  }
`

const StyledContent = styled.div`
  margin: 20px;
  border-radius: 12px;
  background-color: #ffffff;

  @media (max-width: 420px) {
    margin: 0;
    border-radius: 0;
    width: 100vw;
  }
`
const StyledTextArea = styled.textarea`
  width: 100%;
  border-radius: 6px;
  border: 0;
  height: 100px;
  background-color: #f3f5fb;
  resize: none;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Open Sans';
  padding: 14px 20px 10px 20px;
`

const StyledTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  padding-bottom: 14px;
`

const FieldContainer = styled.div`
  padding: 24px 50px 26px 50px;

  @media (max-width: 420px) {
    padding: 18px 24px 8px 24px;
    box-sizing: border-box;
  }
`

const CheckBoxContainer = styled.div`
  border-radius: 6px;
  height: 46px;
  background-color: #f3f5fb;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.3px;
  color: #000000;
  width: 300px;
  user-select: none;
`

const OptionalText = styled.div`
  font-size: 16px;
  user-select: none;
`

const Instructions = ({setValue, move, onNext, onPrevious}) => {
  const localeState = useLocaleState()

  const onChange = ({target}) => {
    const {value} = target

    setValue({
      instructions: value,
      description: value
    })
  }

  const onChangeMoveEquipment = (index, checked) => {
    setValue({
      moveEquipment: checked
    })
  }

  const {type, instructions, moveEquipment, isSaving} = move
  const showMoveEquipment = type === MOVE_SPACE_CHANGE || type === MOVE_GROUP

  return (
    <StyledContainer>
      <StyledContent>
        <FieldContainer>
          <StyledTitle>
            {_L({key: 'Special Instructions', localeState})}
          </StyledTitle>
          <OptionalText>
            {_L({
              key:
                'Optional. Include additional details here, such as the type of space you are requesting or furniture that should be included in the move.',
              localeState
            })}
          </OptionalText>
          <div style={{paddingTop: 10}}>
            <StyledTextArea value={instructions} rows={4} onChange={onChange} />
          </div>

          {showMoveEquipment && (
            <CheckBoxContainer>
              <Checkbox
                checked={moveEquipment}
                onChange={onChangeMoveEquipment}
                label={_L({key: 'Move Equipment?', localeState})}
                index={0}
              />
            </CheckBoxContainer>
          )}
        </FieldContainer>
      </StyledContent>
      <div>
        <NavigationButtons
          onNextClick={onNext}
          nextButtonType={BUTTON_TYPES.DONE}
          onBackClick={onPrevious}
          loading={isSaving}
        />
      </div>
    </StyledContainer>
  )
}

export default Instructions
